import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import EmptyState from '../../../components/EmptyState';

/**
 * Empty state shown when the hotel has no competitors yet.
 */
const NoCompetitors = () => {
    const translate = useTranslate();

    return (
        <EmptyState
            iconName='LeaderboardOutlined'
            title={translate('no_competitors_yet')}
            description={translate('no_competitors_yet_description')}
        />
    );
};

export default NoCompetitors;
